// src/services/serviceFactory.ts
import { IOrganisationService } from './interfaces';
import { OrganisationService } from './api/organisationService';

export class ServiceFactory {
  private static instance: ServiceFactory;
  private organisationService: IOrganisationService;

  private constructor() {
    // Check if we should use mock services based on environment variable
    const useMock = process.env.REACT_APP_USE_MOCK_SERVICES === 'true';

    this.organisationService = OrganisationService.getInstance();
  }

  static getInstance(): ServiceFactory {
    if (!ServiceFactory.instance) {
      ServiceFactory.instance = new ServiceFactory();
    }
    return ServiceFactory.instance;
  }

  getOrganisationService(): IOrganisationService {
    return this.organisationService;
  }
}

// Export the services for easy access
const factory = ServiceFactory.getInstance();
export const organisationService = factory.getOrganisationService();
